import { render, staticRenderFns } from "./FontSmallIcon.vue?vue&type=template&id=ba563362&"
import script from "./FontSmallIcon.vue?vue&type=script&lang=js&"
export * from "./FontSmallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports